module.exports = __webpack_public_path__ + "static/avatar_andrey_malahov@2x-2541c555f68babf0d8b11f4ca18129a9.jpg";